import apiClient from './apiClient';

export const authService = {
  async login(email, password) {
    const response = await apiClient.post('/auth/login', { email, password });
    if (response.data.accessToken) {
      apiClient.setAccessToken(response.data.accessToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  async logout() {
    try {
      await apiClient.post('/auth/logout');
    } finally {
      apiClient.clearTokens();
    }
  },

  async getMe() {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  async forgotPassword(email) {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response;
  },

  async resetPassword(token, password) {
    const response = await apiClient.post(`/auth/reset-password/${token}`, { password });
    return response;
  },

  async getSessions() {
    const response = await apiClient.get('/auth/sessions');
    return response.data;
  },

  async terminateSession(sessionId) {
    const response = await apiClient.delete(`/auth/sessions/${sessionId}`);
    return response;
  },

  async generateModuleToken(moduleId) {
    const response = await apiClient.post(`/auth/module-token/${moduleId}`);
    return response.data;
  },

  getCurrentUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!apiClient.getAccessToken();
  }
};

export default authService;
